export const CITIES = {
  worcester: {
    slug: "worcester",
    name: "Worcester",
    tagline: "Worcester · One City · One Calendar",
    hero: "https://images.unsplash.com/photo-1679391029864-d46f366a456b?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  },
};

export const DEFAULT_CITY = "worcester";
export const getCity = (slug) => CITIES[slug] || null;
